import React from 'react'
import {
  Select,
  InputLabel,
  FormControl,
  FormHelperText
} from '@material-ui/core'

export default ({ field, form, label, children, helperText, ...props }) => {
  const error = form.errors[field.name]
  const touched = form.touched[field.name]
  const showError = touched && !!error

  return (
    <FormControl error={showError} fullWidth component="div">
      <InputLabel htmlFor={field.name}>{label}</InputLabel>
      <Select
        {...props}
        disabled={form.isSubmitting}
        inputProps={{
          id: field.name,
        }}
        native
        name={field.name}
        value={field.value}
        onChange={({target}) => form.setFieldValue(field.name, target.value, true)}
      >
        {children}
      </Select>
      <FormHelperText component="p" error={showError}>{showError ? error : helperText}</FormHelperText>
    </FormControl>
  )
}
